module.exports = __webpack_public_path__ + "img/a.a3d385b7.png";